import script from "./inputElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./inputElement.vue?vue&type=script&setup=true&lang=ts"

import "./inputElement.vue?vue&type=style&index=0&id=2d0868ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d0868ea"]])

export default __exports__